import * as React from "react";
import InstaEmbed from "react-instagram-embed";
import { Box as _Box } from "@quandoo-dev/cookbook/lib/layout";
import styled from "styled-components";

interface InstagramEmbedProps {
  url: string;
}

const Box = styled(_Box)`
  iframe {
    // using !important to override styles
    // set on element by 3rd party(here Instagram API returning
    // this HTML or script modifying it)
    max-width: 800px !important;
  }
`;

const InstagramEmbed: React.FC<InstagramEmbedProps> = ({ url }) => {
  return (
    <Box mt="xs" mb="sm">
      <InstaEmbed url={url} maxWidth={800} />
    </Box>
  );
};

export default InstagramEmbed;
